import { fabric } from "fabric";
import { ModuleInfoPreset } from "../../Types";
import customControls from "./customControlsHelper";

export default {
  addTextOnlyPreset,
  editTextById,
  addTextLogoPreset,
};

function addTextOnlyPreset(canvas: fabric.Canvas, preset: string) {
  let canvasWidth = canvas.getWidth();
  let canvasHeight = canvas.getHeight();
  let text = new fabric.Textbox(preset, {
    ...textCommonPros,
    // @ts-ignore
    id: "quote",
    textAlign: "center",
    left: canvasWidth / 2,
    top: canvasHeight / 2,
    width: canvasWidth - canvasWidth / 3,
    padding: 10,
  });
  //  @ts-ignore
  text.customiseCornerIcons(customControls());
  text.setControlsVisibility({
    mt: false,
    mb: false,
  });
  canvas.add(text);
  canvas.renderAll();
}

function addTextLogoPreset(
  canvas: fabric.Canvas,
  presetTxt: string,
  imageUrl: string
) {
  let canvasWidth = canvas.getWidth();
  let canvasHeight = canvas.getHeight();

  let text = new fabric.Textbox(presetTxt, {
    ...textCommonPros,
    // @ts-ignore
    id: "quote",
    originX: "center",
    originY: "center",
    textAlign: "center",
    left: canvasWidth / 4 + 15,
    top: canvasHeight / 2,
    width: canvasWidth / 3,
    padding: 10,
  });
  text.setControlsVisibility({
    mt: false,
    mb: false,
  });
  //  @ts-ignore
  text.customiseCornerIcons(customControls());
  canvas.add(text);
  fabric.Image.fromURL(imageUrl, (img) => {
    // if the image's being uploaded sizes are greater that canvas size than scale it down
    if (img.width > canvasWidth) {
      img.scaleToWidth(canvasWidth / 2);
    }
    if (img.height > canvasHeight) {
      img.scaleToHeight(canvasHeight / 2);
    }
    img.set({
      // @ts-ignore
      id: `image-${0}`,
      originX: "center",
      originY: "center",
      left: (canvasWidth / 4) * 3,
      top: canvasHeight / 2,
      lockScalingFlip: true,
      lockUniScaling: true,
      padding: 10,
    });
    // @ts-ignore
    img.customiseCornerIcons(customControls());
    canvas.add(img);
  });
  canvas.renderAll();
}

function editTextById(
  canvas: fabric.Canvas,
  id: "quote" | "signature",
  text: string
) {
  canvas.forEachObject((object: any) => {
    if (object.id == id) {
      object.set({
        text: text,
      });
    }
  });
  canvas.renderAll();
}

let textCommonPros: fabric.ITextboxOptions = {
  fill: "#404040",
  fontFamily: "Calibri",
  fontSize:
    window.innerWidth < 360
      ? 8
      : window.innerWidth < 450
      ? 10
      : window.innerWidth < 768
      ? 14
      : 20,
  lockScalingFlip: true,
  lockSkewingX: true,
  lockSkewingY: true,
  originX: "center",
  originY: "center",
  editable: false,
};
